import script from "./ssmoodStudy4.vue?vue&type=script&setup=true&lang=js"
export * from "./ssmoodStudy4.vue?vue&type=script&setup=true&lang=js"

import "./ssmoodStudy4.vue?vue&type=style&index=0&id=1854df08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1854df08"]])

export default __exports__